export type PeakWindow = {
  startHour: number
  endHour: number
}

export const peakWindowFromRateCurve = (curve: number[]): PeakWindow | null => {
  if (curve.length === 0 || !curve.every((rate) => Number.isFinite(rate))) {
    return null
  }

  const maxRate = Math.max(...curve)
  if (curve.every((rate) => rate === maxRate)) {
    return null
  }

  let bestStart = -1
  let bestLength = 0
  let runStart = -1
  let runLength = 0

  curve.forEach((rate, hour) => {
    if (rate === maxRate) {
      if (runStart < 0) {
        runStart = hour
      }
      runLength += 1
      if (runLength > bestLength) {
        bestStart = runStart
        bestLength = runLength
      }

      return
    }

    runStart = -1
    runLength = 0
  })

  if (bestLength === 0) {
    return null
  }

  return { startHour: bestStart, endHour: bestStart + bestLength }
}

const hourClock = (hour: number): { hour12: number; period: `am` | `pm` } => {
  const normalized = ((hour % 24) + 24) % 24

  return {
    hour12: normalized % 12 === 0 ? 12 : normalized % 12,
    period: normalized < 12 ? `am` : `pm`,
  }
}

/** Both ends carry their own am/pm — "4pm – 9pm", never "4–9 pm". Readers of
 * the proposal are matching these hours against a utility bill, so the range
 * has to be unambiguous at a glance rather than compact. */
export const formatPeakWindow = (window: PeakWindow): string => {
  const start = hourClock(window.startHour)
  const end = hourClock(window.endHour)

  return `${start.hour12}${start.period} – ${end.hour12}${end.period}`
}
